import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle cx="25" cy="25" r="24" fill="white" fillOpacity="0.5" />
        <circle cx="25" cy="25" r="24.5" stroke="white" />
      </g>
      <path
        d="M34.8389 18.2718C32.3073 18.2718 30.2477 16.2223 30.2477 13.7031C30.2477 13.3148 29.9313 13 29.5412 13H25.7569C25.3666 13 25.0503 13.3148 25.0503 13.7031V29.1422C25.0503 30.6232 23.8395 31.828 22.3511 31.828C20.8628 31.828 19.6521 30.6232 19.6521 29.1422C19.6521 27.6611 20.8628 26.4562 22.3511 26.4562C22.7414 26.4562 23.0577 26.1415 23.0577 25.7531V21.9874C23.0577 21.5992 22.7414 21.2842 22.3511 21.2842C17.9969 21.2842 14.4546 24.8094 14.4546 29.1422C14.4546 33.475 17.9969 37 22.3511 37C26.7052 37 30.2477 33.475 30.2477 29.1422V22.3082C31.6541 23.0543 33.2189 23.4438 34.8389 23.4438C35.2292 23.4438 35.5455 23.129 35.5455 22.7407V18.9749C35.5455 18.5867 35.2292 18.2718 34.8389 18.2718ZM34.1323 22.0084C32.6238 21.8835 31.1913 21.3591 29.9537 20.4733C29.7386 20.3191 29.4549 20.2979 29.2188 20.4183C28.9829 20.5385 28.8346 20.7802 28.8346 21.044V29.1422C28.8346 32.6996 25.926 35.5938 22.3511 35.5938C18.7762 35.5938 15.8678 32.6996 15.8678 29.1422C15.8678 25.8223 18.4008 23.08 21.6445 22.7286V25.1104C19.7124 25.4448 18.2389 27.1253 18.2389 29.1422C18.2389 31.3986 20.0836 33.2344 22.3511 33.2344C24.6188 33.2344 26.4635 31.3986 26.4635 29.1422V14.4062H28.8758C29.1995 17.14 31.3851 19.3149 34.1323 19.637V22.0084Z"
        fill="#111111"
      />
      <defs>
        <filter
          id="filter0_b"
          x="-10"
          y="-10"
          width="70"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
